import { AddLoad } from 'Components/AddLoad/AddLoad';
import Button from 'Components/UI/Button/Button';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import PageHeader from 'Components/PageHeader/PageHeader';
import PickUp from 'Components/UI/Search/PickUp/PickUp';
import Deliver from 'Components/UI/Search/Deliver/Deliver';
import Vehicle from 'Components/UI/Search/Vehicle/Vehicle';
import Miles from 'Components/UI/Search/Miles/Miles';
import Match from 'Components/UI/Search/Match/Match';
import Brokerage from 'Components/UI/Search/Brokerage/Brokerage';
import PageTable from 'Components/PageTable/PageTable';
import Paginations from 'Components/UI/Pagination/Pagination';
import { useSelector } from 'react-redux';
import {
  selectOrderList,
  selectOrderCount,
  selectOrderLoading,
} from 'Redux/Order/slice';
import { getOrderList } from 'Redux/Order/reducer';
import { useAppDispatch } from 'Redux/store';
import { stringToMiles, formatDate } from 'Shared/Utils';
import styles from './OrdersList.module.scss';

export const OrdersList = () => {
  const dispatch = useAppDispatch();
  const orderList = useSelector(selectOrderList);
  const orderListIsLoading = useSelector(selectOrderLoading);
  const orderCount = useSelector(selectOrderCount);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const baseComponentURL = '/loads';

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = Number(params.get('page')) || 1;
    const pageSize = Number(params.get('page_size'));

    dispatch(getOrderList({ page, pageSize }));
  }, [location.search, dispatch]);

  useEffect(() => {
    dispatch(getOrderList({}));
  }, []);

  const goToCapacityPage = () => {
    navigate('/capacity');
  };

  return (
    <div className={styles.ordersList}>
      <PageHeader content="Loadboard">
        <Button onClick={() => setModalIsOpen(true)}>Add load</Button>

        <AddLoad
          visible={modalIsOpen}
          onCancel={() => setModalIsOpen(false)}
          setOpen={setModalIsOpen}
        />

        <Button onClick={goToCapacityPage}>Capacity search</Button>
      </PageHeader>

      <PageTable
        titles={[
          'Created',
          { name: 'Pick-up at', filterItem: PickUp },
          { name: 'Deliver to', filterItem: Deliver },
          { name: 'Vehicle', filterItem: Vehicle },
          { name: 'Miles', filterItem: Miles },
          { name: 'Match', filterItem: Match },
          { name: 'Brokerage', filterItem: Brokerage },
          'Bids',
        ]}
        rows={
          Boolean(orderList.length)
            ? orderList.map((order) => ({
                id: order.id,
                items: [
                  formatDate({
                    date: order.created_at || order.posted,
                    outputFormat: 'TIME_date',
                  }),
                  order.pick_up_at,
                  order.deliver_to,
                  order.vehicle_required,
                  stringToMiles(order.line) || order.transit_distance || 0,
                  0,
                  '',
                  '',
                ],
              }))
            : []
        }
        baseComponentURL={'/load'}
        isLoading={orderListIsLoading}
      />

      {orderList.length > 0 && (
        <Paginations
          baseComponentURL={baseComponentURL}
          totalCount={orderCount}
        />
      )}
    </div>
  );
};
